import React, { useState, useEffect, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Row, Col, Button, Glyphicon } from 'react-bootstrap'
import axios from 'axios'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

import AuthenticationComponent from '../../../AuthenticationComponent'

import SAPResourceForm from './SAPResourceForm'
import SAPResource from './SAPResource'

const SAPResourceShowPage = props => {
	const [ resource, setResource ] = useState(null)
	const [ fetchingResource, setFetchingResource ] = useState(true)
	const [ editMode, setEditMode ] = useState(false)

	const getResource = () => {
		setFetchingResource(true)
		axios({
			method: 'GET',
			headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
			url: `${getServerURL()}sap-resources/sap-resources/${props.match.params.id}`,
		})
			.then(response => {
				setResource(response.data)
			})
			.catch(error => {
				handleErrorFetchingData(error)
			})
			.finally(() => {
				setFetchingResource(false)
			})
	}

	useEffect(getResource, [])

	const handleSaveSuccess = (response) => {
		setResource(response.data)
		setEditMode(false)
	}

	const userCanEdit = props.currentUser.pk && resource && resource.created_by && resource.created_by.id === props.currentUser.pk

	let content  = (
		<div>
			An error has occurred
		</div>
	)

	if (fetchingResource) {
		content = (
			<center>
				<div id="not-found">
					<img alt="loader" src={require("../../../static/images/spinner.gif")} />
				</div>
			</center>
		)
	} else if (resource && editMode === true) {
		content = (
			<div>
				{userCanEdit ?
					<Fragment>
						<Row>
							<Button
								onClick={() => setEditMode(false)}
								className="back-button"
								style={{marginLeft: '15px'}}
							>
								<Glyphicon glyph="pencil" /> Cancel
							</Button>
						</Row>
						<br />
					</Fragment>
					:
					null
				}
				<SAPResourceForm
					resource={resource}
					handleSaveSuccess={handleSaveSuccess}
				/>
			</div>
		)
	} else if (resource) {
		content = (
			<div>
				{userCanEdit ?
					<Fragment>
						<Row>
							<Button
								onClick={() => setEditMode(true)}
								className="back-button"
								style={{ marginLeft: '15px' }}
							>
								<Glyphicon glyph="pencil" /> Edit Post
							</Button>
						</Row>
						<br />
					</Fragment>
					:
					null
				}
				<SAPResource resource={resource} currentUser={props.currentUser} />
			</div>
		)
	}

	return (
		<div id="ResourcePostPageContainer">
			<AuthenticationComponent />
			<Row id="post-content">
				<Col md={4}>
					<div>
						<Link to="/sap-repository">
							<Button className="back-button">
								<Glyphicon glyph="arrow-left" /> Back
							</Button>
						</Link>
					</div>
				</Col>
			</Row>
			{content}
		</div>
	)
}

const mapDispatchToProps = state => {
	return {
		currentUser: state.manageLogin.user,
	}
}

export default connect(mapDispatchToProps)(SAPResourceShowPage)


// WEBPACK FOOTER //
// ./src/routes/sap-resources/components/SAPResourceShowPage.js